/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { permissionState } from "./permissions.state";

const permissions = createSlice({
    name: "permissions",

    initialState: permissionState,

    reducers: {
        setPermissions (state, action) {
            state.all = action.payload;
        },
        setPermissionsReady (state, action) {
            state.ready = action.payload;
        },
        setPermissionMappings (state, action) {
            state.mappings = action.payload;
        },
        setPermissionItem (state, action) {
            const permission = action.payload;
            const guid = permission.guid;
            state.byGUID[guid] = permission;
            state.current = permission;
        },
    },
});

export const permissionsReducer = permissions.reducer;

export const {
    setPermissionsReady,
    setPermissionItem,
    setPermissions,
    setPermissionMappings
} = permissions.actions;
